/**
 * Transforme un step (string ou objet {type, text}) en string lisible pour l'affichage React.
 * @param {string|object} step - Étape à afficher
 * @returns {string}
 */
export function renderStep(step) {
  if (typeof step === "object" && step !== null) {
    // Certains steps peuvent ne pas avoir de type ou de text
    if (Array.isArray(step)) return step.map(renderStep).join(" ");
    return [step.type, step.text].filter(Boolean).join(" ");
  }
  return typeof step === "string" ? step : "";
}